"use client";

import { createContext, type ReactNode, useContext } from "react";
import type { PdpParams } from "@/lib/product/pdpParams";

const PdpParamsContext = createContext<PdpParams>({});

interface PdpParamsProviderProps {
  children: ReactNode;
  params: PdpParams;
}

export function PdpParamsProvider({ children, params }: PdpParamsProviderProps) {
  return <PdpParamsContext.Provider value={params}>{children}</PdpParamsContext.Provider>;
}

export function usePdpParams() {
  return useContext(PdpParamsContext);
}
